import { render, staticRenderFns } from "./Showrooms.vue?vue&type=template&id=2dfdb731&scoped=true&"
import script from "./Showrooms.vue?vue&type=script&lang=js&"
export * from "./Showrooms.vue?vue&type=script&lang=js&"
import style0 from "./Showrooms.vue?vue&type=style&index=0&id=2dfdb731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdb731",
  null
  
)

export default component.exports